<template>
  <div
    class="
      room-primary
      flex-grow-1
      d-flex
      flex-column
      justify-content-center
      align-items-center
    "
  >
    <template v-if="roomInfoList && courtsInfo">
      <div
        v-if="roomInfoList && roomInfoList.length > 1"
        class="
          select-option-container
          position-absolute
          d-flex
          justify-content-center
        "
      >
        <select-options-nav
          @selectOption="getSelectOption"
          :selectOption="selectOrder"
          :selectList="selectOptionList"
        ></select-options-nav>
      </div>
      <div class="svg-container none-height flex-grow-1 w-100 d-flex">
        <room-whole-primary-diagram
          class="primary-diagram-svg"
          style="width: 100%; max-width: 100%; height: auto"
          v-if="courtsInfo && courtsInfo.TaiQv"
          v-on:transClick="showCourtHome"
          @showAllProps="showAllProps"
          :courtsInfo="courtsInfo"
          :equipIdPropArray="subEquipInfoList"
          @propClick="showPropCurve"
        ></room-whole-primary-diagram>
      </div>
    </template>
    <no-data-temporarily v-else></no-data-temporarily>
    <el-dialog
      diaId="video-dia"
      :visible.sync="showVideo"
      :title="diaTitle_1"
      :class="{ dark: skinType }"
    >
      <monitoring-curve
        v-if="secDiaType == 1"
        :is_columnar_flag="is_columnar_flag"
        :equipType="equipType"
        :propInfo="propInfo"
        :equipmentInfo="selectEquipment"
        class="flex-grow-1"
        style="min-height: 400px"
      ></monitoring-curve>
      <div v-else class="overflow-y flex-wrap">
        <el-table
          size="small"
          :class="{ dark: skinType }"
          stripe
          :data="propertiesData"
          :row-class-name="
            (...nu) => {
              return skinType ? 'dark text-white' : '';
            }
          "
        >
          <el-table-column prop="Name" label="属性名称"></el-table-column>
          <el-table-column prop="Code" label="属性代码"></el-table-column>
          <el-table-column prop="Value" label="属性值"></el-table-column>
          <el-table-column prop="Time" label="记录时间"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import roomWholePrimaryDiagram from '@/components/svgs/room-whole-primary-diagram.vue';
import monitoringCurve from '@/components/general/monitoring-curve.vue';
import selectOptionsNav from '@/components/general/select-options-nav.vue';
import { getDiagramData } from '@/api/switchroom';
import clone from '@/utils/clone';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import TurnAskingMixin from '@/mixins/turn-ask';

export default {
  name: 'room-primary',
  mixins: [TurnAskingMixin],
  props: {
    projectInfo: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  components: {
    roomWholePrimaryDiagram,
    monitoringCurve,
    selectOptionsNav,
    NoDataTemporarily,
  },
  data() {
    return {
      roomPrimaryTimeout: null,
      routeName: '',
      courtToId: '',
      showVideo: false,
      secDiaType: 0,
      selectEquipment: {},
      activeVideoId: 0,
      showDia: false,
      selectOutline: '',
      roomId: '',
      roomName: '',
      courtsInfo: {},
      envirInfo: {},
      branchTree: [],
      diaType: 0, // 0  1 2 概况
      diaSize_0: {
        x: 10,
        y: 10,
      },
      diaSize_1: {
        x: 10,
        y: 10,
      },
      diaTitle_1: '',
      equipType: 0,
      roomInfoList: [],
      selectOptionList: [],
      selectOrder: 0,
      primaryType: 3,
      subEquipPropsList: [],
      // 设备信息键值对
      subEquipInfoMap: new Map(),
      mapCount: 0,
      subEquipInfoList: [],
      is_columnar_flag: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    this.changeHomeBgType(0);
    clearTimeout(this.courtToId);
    next();
  },
  mounted() {
    this.routeName = this.$route.name;
    this.getCourtList();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    // 属性tableData
    propertiesData() {
      return this.selectEquipment.JCX;
    },
    selectCourt: {
      get() {
        return this.$store.state.selectCourt;
      },
    },
    accountId: {
      get() {
        return this.$store.state.accountId;
      },
    },
    // 配电室信息
    roomInfo: {
      get() {
        return this.$store.state.roomInfo;
      },
    },
    // 台区信息
    courtInfo: {
      get() {
        return this.$store.state.courtInfo;
      },
    },
    subResultInfo: {
      get() {
        return this.$store.state.subResultInfo;
      },
    },
  },
  watch: {
    mapCount() {
      this.subEquipInfoList = Array.from(this.subEquipInfoMap);
    },
    projectInfo() {
      this.selectOrder = 0;
      this.getCourtList();
    },
    roomInfoList(newVal) {
      if (newVal == null) {
        this.courtsInfo = null;
        return;
      }
      this.courtsInfo = clone(newVal[this.selectOrder]);
    },
    selectOrder() {
      this.courtsInfo = clone(this.roomInfoList[this.selectOrder]);
    },
  },
  methods: {
    changeEquipMap(list) {
      for (let j = 0; j < list.length; j += 1) {
        const item = list[j];
        const oldProps = this.subEquipInfoMap.get(item.EquipmentID);
        for (let i = 0; i < oldProps.length; i += 1) {
          let prop = oldProps[i];
          if (prop.ID === item.PropertyID) {
            prop = item.PropertyValue;
          }
        }
      }
      this.mapCount += 1;
    },
    subscribeProps(propList, isSub) {
      if (propList.length === 0) {
        return;
      }
      if (isSub === 2) {
        this.removeListEquipments(propList);
      }
    },
    removeListEquipments(propList) {
      for (let i = 0; i < propList.length; i += 1) {
        const item = propList[i];
        this.subEquipInfoMap.delete(item.EquipmentID);
      }
      this.mapCount -= 1;
    },
    // 订阅设备信息
    getSubCourtsProps() {
      let arr = [];
      for (let i = 0; i < this.courtsInfo.TaiQv.length; i += 1) {
        const info = this.courtsInfo.TaiQv[i];
        const transProps = this.getEquipPropFromList(info.BYQ);
        arr = [...arr, ...transProps];

        const incomeLinesProps = this.getEquipPropFromList(info.JX);

        const outLinesProps = this.getEquipPropFromList(info.CX);
        arr = [...arr, ...incomeLinesProps, ...outLinesProps];
      }
      const contactCabinetProps = this.getEquipPropFromList(
        this.courtsInfo.LianLuoGui,
      );
      arr = [...arr, ...contactCabinetProps];
      return arr;
    },
    getEquipPropFromList(list) {
      const propsList = [];
      for (let i = 0; i < list.length; i += 1) {
        const item = list[i];
        const itemProp = {
          EquipmentID: item.TabIDstr,
          List_PropertyID: item.JCX.map((prop) => prop.ID),
        };
        this.subEquipInfoMap.set(item.TabIDstr, item.JCX);
        propsList.push(itemProp);
      }
      this.mapCount += 1;
      return propsList;
    },
    showPropCurve(propInfo, item) {
      console.log(propInfo, item)
      this.equipType = propInfo.ID;
      this.propInfo = propInfo;
      this.secDiaType = 1;
      this.diaTitle_1 = `${item.SBMName}--${propInfo.Name}`;
      this.selectEquipment = item;
      this.setDiaSize(10, 10, 1);
      if (propInfo.Code === 'zygsz') {
        this.is_columnar_flag = true;
      } else {
        this.is_columnar_flag = false;
      }
      this.showVideo = true;
    },
    // 展示所有属性
    showAllProps(equipInfo, type = this.primaryType ? 3 : 0) {
      this.equipType = type;
      this.secDiaType = 2;
      this.diaTitle_1 = equipInfo.SBMName ? equipInfo.SBMName : equipInfo.Name;
      this.selectEquipment = equipInfo;
      this.setDiaSize(10, 10, 1);
      this.showVideo = true;
    },
    // 获取选择的Option
    getSelectOption(order) {
      this.selectOrder = order;
    },
    // 关掉视频
    closeVideo() {
      this.showVideo = false;
    },
    showCamero() {
      this.diaTitle_1 = '';
      this.showVideo = true;
      this.secDiaType = 0;
    },
    getCourtList() {
      clearTimeout(this.roomPrimaryTimeout);
      if (!this.projectInfo || !this.projectInfo.IdStr) {
        this.selectOptionList = null;
        this.roomInfoList = null;
        return;
      }
      getDiagramData({
        PDSIDstr: this.projectInfo.IdStr,
      })
        .then((response) => {
          if (response == null) {
            this.selectOptionList = null;
            this.roomInfoList = null;
            return;
          }
          this.changeInfosToList(response);
        })
        .catch((failInfo) => {
          console.log(failInfo);
        })
        .then(() => {
          this.roomPrimaryTimeout = this.turnAsking(
            {
              routeName: this.routeName,
              nowRouteName: this.$route.name,
              func: this.getCourtList,
            },
            5000,
          );
        });
    },
    changeInfosToList(roomInfo) {
      const len = roomInfo.TaiQv.length;
      const realLen = Math.ceil(len / 2);
      const arr = [];
      const nameArr = [];
      for (let i = 0; i < realLen; i += 1) {
        nameArr.push(`第${i + 1}组`);
        const twoCourts = {
          TaiQv: clone(roomInfo.TaiQv.slice(i * 2, (i + 1) * 2)),
          LianLuoGui: clone(roomInfo.LianLuoGui.slice(i, i + 1)),
        };
        arr.push(twoCourts);
      }
      this.selectOptionList = nameArr;
      this.roomInfoList = arr;
    },
    showCourtHome(courtInfo = { TaskIDstr: '', SBMName: '' }) {
      const selectCourtInfo = this.getSelectCourtInfo(courtInfo.TaskIDstr);
      this.changeSelectCourtInfo(selectCourtInfo);
      this.$router.push({
        name: 'court-home',
        params: {
          courtId: selectCourtInfo.Code,
          courtName: selectCourtInfo.Name,
          typeId: 1,
        },
      });
    },
    getSelectCourtInfo(courtId) {
      for (let i = 0; i < this.roomInfo.C.length; i += 1) {
        const courtInfo = this.roomInfo[i].C[i];
        if (courtInfo.Code === courtId) {
          return courtInfo;
        }
      }
      return null;
    },
    showCurve(equipInfo, type = this.primaryType ? 3 : 0) {
      this.equipType = type;
      this.secDiaType = 1;
      this.diaTitle_1 = equipInfo.SBMName ? equipInfo.SBMName : equipInfo.Name;
      this.selectEquipment = equipInfo;
      this.setDiaSize(10, 10, 1);
      this.showVideo = true;
    },
    requsetOutlineData(outline) {
      console.log(outline);
    },
    setDiaSize(x, y, type) {
      if (type === 0) {
        this.$set(this.diaSize_0, 'x', x);
        this.$set(this.diaSize_0, 'y', y);
      } else {
        this.$set(this.diaSize_1, 'x', x);
        this.$set(this.diaSize_1, 'y', y);
      }
    },
  },
};
</script>
<style scoped>
.no-data-hint {
  font-size: 30px;
  color: #999999;
}
.branchInfo {
  width: 200%;
}
.svg-container {
  overflow-x: hidden;
}
.marquee-control {
  bottom: 3rem;
}
.room-primary {
  width: 100%;
}
/* .none-height{
  border: 1px red solid;
} */
.select-option-container {
  top: 3rem;
  z-index: 200;
}
</style>
